import React, { useState, useEffect } from 'react';

import { ChevronUp, ChevronDown } from 'lucide-react';

import { Checkbox, TableHead, TableRow } from '#/components/ui';
const SortableTableHeader = ({ headers, setQueryParams, allSelected, onSelectAll }) => {
    const [sortConfig, setSortConfig] = useState({ field: null, order: null });

    const handleSortClick = field => {
        setSortConfig(prev => {
            const isSameField = prev.field === field;
            const newOrder = isSameField && prev.order === 'asc' ? 'desc' : 'asc';
            return { field, order: newOrder };
        });
    };

    useEffect(() => {
        if (sortConfig.field && sortConfig.order) {
            setQueryParams(prev => ({
                ...prev,
                ordering: sortConfig.order === 'asc' ? sortConfig.field : `-${sortConfig.field}`,
            }));
        }
    }, [sortConfig, setQueryParams]);

    return (
        <TableRow className='font-inter text-xs font-medium text-gray500'>
            {headers?.map(item => {
                const isActive = sortConfig.field === item.sortKey;

                return (
                    <TableHead
                        key={item.id}
                        onClick={() => item.sorting && handleSortClick(item.sortKey)}
                        className={`${item.isCheckBox ? 'px-6' : 'px-4'} w-1/5 ${item.sorting ? 'cursor-pointer select-none' : ''}`}
                    >
                        <div className='flex items-center gap-2'>
                            {item.isCheckBox && (
                                <Checkbox
                                    className='w-4 h-4'
                                    checked={allSelected}
                                    onCheckedChange={onSelectAll}
                                    onClick={e => e.stopPropagation()}
                                />
                            )}
                            {item.label}
                            {item.sorting && (
                                <span className='flex flex-col justify-center items-center'>
                                    <ChevronUp
                                        className={`h-3 w-3 ${
                                            isActive && sortConfig.order === 'asc' ? 'text-black' : 'text-gray-300'
                                        }`}
                                    />
                                    <ChevronDown
                                        className={`h-3 w-3 ${
                                            isActive && sortConfig.order === 'desc' ? 'text-black' : 'text-gray-300'
                                        }`}
                                    />
                                </span>
                            )}
                        </div>
                    </TableHead>
                );
            })}
        </TableRow>
    );
};

export { SortableTableHeader };
